const PricingDetails = [
    {
      packageName: "Basic",
      label:
        "30-day free trial for your first App",
      features: [
        "1 Branches",
        "3 Categories",
        "15 Items",
        "1 Payment Gateways",
        "1 Fullfilment method",
        "No Order Tracking Module",
        "No Stock Manager Module"
      ],
      price: "£0",
      action: "Buy Now",
      quantity: 1,
      id: "Basic",
      isDefault:false
    },
    {
      packageName: "Standard",
      label:
        "Card payments accepted",
      features: [
        "1 Branches",
        "3 Categories",
        "15 Items",
        "1 Payment Gateways",
        "1 Fullfilment method",
        "No Order Tracking Module",
        "No Stock Manager Module"
      ],
      price: "£15",
      action: "Buy Now",
      quantity: 1,
      id: "Standard",
      isDefault:true
    },
    {
      packageName: "Premium",
      label:
      "Card payments accepted",
      features: [
        "1 Branches",
        "3 Categories",
        "15 Items",
        "1 Payment Gateways",
        "1 Fullfilment method",
        "No Order Tracking Module",
        "No Stock Manager Module"
      ],
      price: "£50",
      action: "Buy Now",
      quantity: 1,
      id: "Premium",
      isDefault:false
    },
    {
      packageName: "Multi Outlet Enterprise",
      label:
        "Contact us for more details",
      features: [
        "1 Branches",
        "3 Categories",
        "15 Items",
        "1 Payment Gateways",
        "1 Fullfilment method",
        "No Order Tracking Module",
        "No Stock Manager Module"
      ],
      price: "",
      action: "Call us for price",
      quantity: 1,
      id: "MultiOutletEnterprise",
      isDefault:false
    }
  ];
  
  export default PricingDetails;
  